"use client";

import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { LogOut } from 'lucide-react';

const Logout = () => {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const handleConfirm = async () => {
    await signOut();
    // No need for explicit navigate here; signOut will trigger the listener to go to /login
  };

  const handleCancel = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1">
          <CardTitle className="flex items-center justify-center space-x-2">
            <LogOut className="h-5 w-5" />
            <span>Confirm Logout</span>
          </CardTitle>
          <CardDescription>Are you sure you want to log out? You'll need to sign in again to access your account.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex justify-center space-x-4">
            <Button variant="outline" onClick={handleCancel}>
              Cancel
            </Button>
            <Button onClick={handleConfirm}>
              Log Out
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Logout;